import React from 'react';
import { GlobalDesignActionPanel } from '../types';
import { AutomaticPanel } from '../../automaticPanel/AutomaticPanel';

const CornerStyles: GlobalDesignActionPanel = (props) => {
  return <AutomaticPanel host={props.host} />;
};

export default CornerStyles;
